//core
import React from "react";

//redux
//material
import {
    Avatar,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Typography,
} from "@mui/material";
import {useMainTranslation} from "../../../../../../../newShared/hooks/useMainTranslationHooks/useMainTranslation";
import {TextArea} from "../../../../../../../newShared/components/Inputs";
import {UploadFileBTN} from "../../../UploadFileBTN";
import {ACCEPT_IMAGE_PROP} from "../../../../../../../newShared/constants";
import {useAddFramework} from "../../../../hooks/dialogs/useAddFramework";
import {LoadingButton} from "@mui/lab";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import colors from "../../../../../../../newShared/theme/colors";
import {DEFAULT_LOGO_URL} from "../../../../../../authWorkspacesCookies/settings/constants";


export const AddFrameworkDialog = () => {
    const {t, revDir} = useMainTranslation('', {keyPrefix: 'builderPage.dialogs'});
    const {
        isOpen,
        fileName,
        framework,
        handleGenerateLogo,
        handleSelect,
        handleClose,
        handleChange,
        setLogo,
        validate,
        isLoading,
        handleDeleteLogo,
        errorMessage,
    } = useAddFramework();

    return (
        <Dialog open={isOpen} onClose={handleClose} maxWidth={'lg'} sx={{'& .MuiPaper-root': {maxHeight: '700px', margin: '30px 0 0 0'}}}>
            <DialogTitle>{t('Create framework')}</DialogTitle>
            <DialogContent>
                <Box display={'flex'} width={'100%'} alignItems={'center'}>
                    { fileName === '' ?
                        <>
                            <UploadFileBTN accept={ACCEPT_IMAGE_PROP} id={'frameLogo'}
                                           onChange={(e) => setLogo(e.currentTarget.files![0])}
                                           variant={'text'}
                                           text={t('Upload your logo')}
                                           sx={{width: 'max-content', '&.MuiButton-text': {textTransform: 'none', pl: '0px', pr: '0px'}}}/>

                            <Typography variant={'body2'} sx={{ml: '8px', mr: '8px'}}>{t('or')}</Typography>

                            <Avatar
                                src={(framework.logo.length > 0) ? framework.logo : undefined}
                                sx={{width: '35px', height: '35px', mr: !revDir ? '6px' : undefined, ml: revDir ? '6px' : undefined, backgroundColor: 'inherit'}}
                                children={<img src={DEFAULT_LOGO_URL} height='32px' width='32px' alt={'framework logo'}/>}
                            />

                            <Button variant={'text'} sx={{'&.MuiButton-text': {textTransform: 'none', pl: '0px', pr: '0px'}}} onClick={handleGenerateLogo}>{t('Generate logo')}</Button>
                        </>
                        :
                        <Box display={'flex'} alignItems={'center'} width={'100%'}>
                            <Avatar
                                src={(framework.logo.length > 0) ? framework.logo : undefined}
                                sx={{width: '35px', height: '35px', mr: !revDir ? '6px' : undefined, ml: revDir ? '6px' : undefined, backgroundColor: 'inherit'}}
                            />
                            {/*<Typography fontSize={'12px'} fontWeight={'400'} lineHeight={'20px'}>{fileName}</Typography>*/}
                            <DeleteForeverIcon sx={{width: '18px', height: '20px', ml: '8px', mr: '8px', color: colors.text.grey, cursor: 'pointer'}} onClick={handleDeleteLogo} />
                        </Box>

                    }
                </Box>
                {errorMessage ?
                    <Typography variant={'body2'} color={colors.text.critical}>{errorMessage}</Typography>
                    :
                    <>
                        {fileName === '' && <Typography variant={'body2'} >{t('Logo (rectangle image up to 1 MB)')} </Typography>}
                    </>

                }


                <TextField
                    sx={{width: '100%', mt: '12px', '& label': {top: '0 !important'}}}
                    size={'small'}
                    required
                    // margin="dense"
                    id="name"
                    label={t("Name")}
                    type="text"
                    value={framework.name}
                    name={'name'}
                    onChange={handleChange}
                />


                <TextField
                    sx={{width: '100%', mt: '12px', '& label': {top: '0 !important'}}}
                    size={'small'}
                    // margin="dense"
                    id="name"
                    label={t("Type")}
                    type="text"
                    value={framework.type}
                    name={'type'}
                    onChange={handleChange}
                />

                <TextArea
                    sx={{mt: '12px'}}
                    // margin="dense"
                    id="name"
                    label={t("Description")}
                    type="text"
                    value={framework.description}
                    name={'description'}
                    onChange={handleChange}
                    rows={5}
                    minRows={5}
                />


            </DialogContent>
            <DialogActions>
                <Button variant={'text'} sx={{'&.MuiButton-text': {textTransform: 'none'}}} onClick={handleClose} >{t('Cancel')}</Button>

                <LoadingButton size={'medium'}
                               variant={'contained'}
                               disabled={!validate() || isLoading}
                               onClick={handleSelect} loading={isLoading }
                               loadingPosition={isLoading ? 'end' : undefined}
                               endIcon={isLoading ? <div style={{width: '10px', height: '10px', marginLeft: revDir ? '12px' : undefined, marginRight: !revDir ? '12px' : undefined }}/> : undefined}
                >
                    {t('Save')}
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}
